import React from 'react';

/** Heading block — section title. data: { text, level? } */
export default function Heading({ data = {} }) {
  const { text = '', level = 'h2' } = data;
  if (!text) return null;
  const cls =
    level === 'h2'
      ? 'text-2xl lg:text-4xl font-bold tracking-tight orka-text-primary'
      : 'text-xl lg:text-2xl font-semibold orka-text-primary';
  const Tag = level === 'h3' ? 'h3' : 'h2';
  return (
    <section data-testid="site-block-heading">
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-4">
        <Tag className={cls}>{text}</Tag>
      </div>
    </section>
  );
}
